// "Jeremy Bromm" -> "JB"; falls back to the first two characters for single-word names. Shared by
// App.js and ExternalApp.js so both header avatars render a signed-in name identically -- a plain
// util file rather than a shared component/service layer (CLAUDE.md Section 6).
export function initialsOf(name) {
  const parts = (name || '').trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '?';
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}
